import axios from 'axios';
import { variables } from '../Variables';

export const getEstateJobStatus = async (estateId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetEstateJobStatus?estateId=${estateId}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data) {
            //console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log("api error", error);
        return "error";
    }
}




